import Typography from '@mui/material/Typography';
import {  Box, Grid } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { ReactChild, ReactFragment, ReactPortal, useContext } from "react";
import { AppContext } from "../context";


export default function PlanInfo() {
  const {plan} = useContext<any>(AppContext);


  return (
    <Grid container direction='column' 
    sx={{
    maxWidth: 300,
    border: 2,
    borderColor: 'primary.main',
    borderRadius: 3,
    alignItems:'center', 
    margin: '10px auto'}}>
      <Box sx={{
        margin: '10px auto 0px'}}>
      <Typography variant="h6"color='primary.main'>
        Plano Selecionado:
      </Typography>
      </Box>
      <Box sx={{
        margin: '3px auto'}}>
      <Typography variant="subtitle1" color='primary.main'>
        {plan.plan_selected}
      </Typography>
      </Box>
      <Box sx={{width: '80%', display: 'flex', flexDirection: 'column' ,justifyContent: 'flex-start', mb: 2}}>
      {plan.plans_description.map((product: any) => (
        <Box sx={{ width: '100%', display: "flex", alignItems: "center",  }}>
          <Box sx={{
            backgroundColor: 'primary.main',
            borderRadius: 1.5,
            p: 1,
            m: 0.7,
            display: 'flex',
            justifyContent: 'center',
            width: '40px',
            height: '40px'
            }}>
          <img src={product.productDetailIconUrl} alt='icon' width='20px' height='20px'/>
          </Box>
          <Typography variant="body2" >
            {product.productDetailName}
          </Typography>
        </Box>
      ))}
      </Box>
    </Grid>
  );
}